const TiposAtendimento = [
    { cod: "vital", descricao: "Vital"},
    { cod: "programado", descricao: "Programado"},
    { cod: "bbn-alta", descricao: "BBN Alta"},
    { cod: "bbn-media", descricao: "BBN Média"},
  ];

  export default TiposAtendimento